import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import { useCallback } from 'react';

/** Actions available on the logger stream cursor menu. */
export type CursorMenuAction =
  | 'play'
  | 'pause'
  | 'start_selection'
  | 'end_selection'
  | 'create_fragment'
  | 'copy_url'
  | 'clear';

/**
 * PostHog capture for cursor menu clicks.
 * Events are sent as `logger:cursor_menu_action` with an `action` property.
 */
export function useCursorMenuCapture() {
  const capture = usePostHogCapture({ domain: 'logger' });

  return useCallback(
    (action: CursorMenuAction) => {
      capture('cursor_menu_action', { action });
    },
    [capture],
  );
}
